
import { memo } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const ParetoConfig = memo(({ data, onChange, inputColumns }: any) => {

    return (
        <div className="space-y-6">
            <div className="space-y-3">
                <Label className="text-xs font-semibold text-gray-700 uppercase tracking-wider">Pareto Settings</Label>

                <div className="space-y-2">
                    <div className="space-y-1">
                        <Label className="text-[10px] uppercase font-semibold text-gray-500">Value Column (Metric)</Label>
                        <Select
                            value={data.valueColumn || ''}
                            onValueChange={(v) => onChange('valueColumn', v)}
                        >
                            <SelectTrigger className="w-full text-xs">
                                <SelectValue placeholder="Select Column..." />
                            </SelectTrigger>
                            <SelectContent>
                                {inputColumns.map((c: any) => (
                                    <SelectItem key={c.name} value={c.name}>{c.name}</SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </div>

                    <div className="space-y-1">
                        <Label className="text-[10px] uppercase font-semibold text-gray-500">Category Column (Dimension)</Label>
                        <Select
                            value={data.categoryColumn || ''}
                            onValueChange={(v) => onChange('categoryColumn', v)}
                        >
                            <SelectTrigger className="w-full text-xs">
                                <SelectValue placeholder="Select Column..." />
                            </SelectTrigger>
                            <SelectContent>
                                {inputColumns.map((c: any) => (
                                    <SelectItem key={c.name} value={c.name}>{c.name}</SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </div>

                    <div className="space-y-1">
                        <Label className="text-[10px] uppercase font-semibold text-gray-500">Threshold (0-1)</Label>
                        <Input
                            className="text-xs"
                            placeholder="0.8"
                            type="number"
                            step="0.1"
                            min="0"
                            max="1"
                            value={data.threshold || 0.8}
                            onChange={(e) => onChange('threshold', parseFloat(e.target.value))}
                        />
                        <p className="text-[9px] text-gray-400">Default 0.8 (80%)</p>
                    </div>
                </div>
            </div>
        </div>
    );
});
